import { z } from 'zod'

/**
 * Where an envelope came from: `api` when an API key created it directly,
 * `mcp` when it came through an AI app over MCP (a person, or an API key used
 * from an AI app). Receivers can ignore envelopes their own system didn't
 * create.
 */
export const ENVELOPE_CREATED_VIA = ['api', 'mcp'] as const

export const envelopeCreatedViaSchema = z.enum(ENVELOPE_CREATED_VIA)

export type EnvelopeCreatedVia = z.infer<typeof envelopeCreatedViaSchema>

export const PRISMA_ENVELOPE_CREATED_VIA = ['API', 'MCP'] as const

export type PrismaEnvelopeCreatedVia = (typeof PRISMA_ENVELOPE_CREATED_VIA)[number]

export const ENVELOPE_CREATED_VIA_FROM_PRISMA = {
  API: 'api',
  MCP: 'mcp',
} as const satisfies Record<PrismaEnvelopeCreatedVia, EnvelopeCreatedVia>

export const ENVELOPE_CREATED_VIA_TO_PRISMA = {
  api: 'API',
  mcp: 'MCP',
} as const satisfies Record<EnvelopeCreatedVia, PrismaEnvelopeCreatedVia>
